import { servicesTableColumns } from '../../constants/tableColumns';
import { useServiceContext } from '../../contexts/ServiceProvider';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreateServiceAction from './CreateServiceAction';

const ShowAllServices = () => {
  // integration of context hooks here
  const { serviceList, isError, isLoading, isSuccess } = useServiceContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('service');

  // rendering show all services section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader headerText='All Services' />

            <AcademiaTable
              data={serviceList}
              columns={servicesTableColumns}
              tableToolbarComponent={
                <CreateServiceAction
                  serviceList={serviceList}
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                  hasUpdatePermission={featureBasedPermissions.includes(
                    'UPDATE'
                  )}
                />
              }
              notFoundMessage='No service found!'
              hasMultipleToolbarComponents
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load service data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllServices;
